/**
 * Joins parts into a kebab-case data-testid string for Playwright's `getByTestId(...)` selectors.
 */
export function testId(...parts: Array<string | number>): string {
  return parts.map(part => String(part)).join('-')
}
